import { Flex } from '@chakra-ui/react';
import { TagInputDisplay } from './TagInputDisplay';
import { FormFieldTagInput } from '.';
import { DiffModal } from '../common/DiffModal';

interface Props {
  value: string[];
  previousValue: string[];
  onClose: () => void;
  config: FormFieldTagInput;
}

export const TagDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const prevZeroState = value && !previousValue;
  const currentZeroState = previousValue && !value;
  const label = config.params.labels.main;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {prevZeroState ? zeroState : <TagInputDisplay value={previousValue} />}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {currentZeroState ? (
          zeroState
        ) : (
          <TagInputDisplay value={value} />
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
